import { useEffect } from "react";

const addBodyClass = (className: string) => document.body.classList.add(className);
const removeBodyClass = (className: string) => document.body.classList.remove(className);

// Adapted from https://stackoverflow.com/a/55537134/349353
export function useBodyClass(classNames: string | string[]) {
  useEffect(() => {
    Array.isArray(classNames) ? classNames.forEach(addBodyClass) : addBodyClass(classNames);

    return () => {
      Array.isArray(classNames) ? classNames.forEach(removeBodyClass) : removeBodyClass(classNames);
    };
  }, [classNames]);
}
